import { Button, Col, Form, Row, Spinner } from "react-bootstrap";

const DriverExpenseForm = ({
  form,
  validationErrors,
  submitting,
  isEditMode,
  associatedDriverName,
  drivers,
  isDriversLoading,
  onSubmit,
  onFieldChange,
  onReset,
}) => {
  return (
    <Form onSubmit={onSubmit}>
      <Row>
        <Col md={6}>
          <Form.Group className="mb-3">
            <Form.Label>Driver</Form.Label>
            {isEditMode ? (
              <Form.Control type="text" value={associatedDriverName || "-"} readOnly disabled />
            ) : (
              <Form.Select
                value={form.driverId}
                onChange={(e) => onFieldChange("driverId", e.target.value)}
                isInvalid={!!validationErrors.driverId}
                disabled={isDriversLoading}
              >
                <option value="">Select Driver</option>
                {drivers.map((driver) => (
                  <option key={driver?._id} value={driver?._id}>
                    {driver?.name || "Unnamed Driver"}
                  </option>
                ))}
              </Form.Select>
            )}
            <Form.Control.Feedback type="invalid">
              {validationErrors.driverId}
            </Form.Control.Feedback>
          </Form.Group>
        </Col>

        <Col md={6}>
          <Form.Group className="mb-3">
            <Form.Label>No. of Days</Form.Label>
            <Form.Control
              type="number"
              min="1"
              value={form.noOfDays}
              onChange={(e) => onFieldChange("noOfDays", e.target.value)}
              placeholder="2"
              isInvalid={!!validationErrors.noOfDays}
            />
            <Form.Control.Feedback type="invalid">
              {validationErrors.noOfDays}
            </Form.Control.Feedback>
          </Form.Group>
        </Col>

        <Col md={6}>
          <Form.Group className="mb-3">
            <Form.Label>Salary Per Day</Form.Label>
            <Form.Control
              type="number"
              min="1"
              value={form.salaryPerDay}
              onChange={(e) => onFieldChange("salaryPerDay", e.target.value)}
              placeholder="1200"
              isInvalid={!!validationErrors.salaryPerDay}
            />
            <Form.Control.Feedback type="invalid">
              {validationErrors.salaryPerDay}
            </Form.Control.Feedback>
          </Form.Group>
        </Col>

        <Col md={6}>
          <Form.Group className="mb-3">
            <Form.Label>Total Amount</Form.Label>
            <Form.Control
              type="number"
              min="1"
              value={form.totalAmount}
              onChange={(e) => onFieldChange("totalAmount", e.target.value)}
              placeholder="2400"
              isInvalid={!!validationErrors.totalAmount}
            />
            <Form.Control.Feedback type="invalid">
              {validationErrors.totalAmount}
            </Form.Control.Feedback>
          </Form.Group>
        </Col>
      </Row>

      <div className="d-flex gap-2 mt-2">
        <Button type="submit" disabled={submitting}>
          {submitting ? (
            <>
              <Spinner as="span" animation="border" size="sm" className="me-2" />
              {isEditMode ? "Saving..." : "Creating..."}
            </>
          ) : (
            isEditMode ? "Save Changes" : "Create Driver Expense"
          )}
        </Button>
        <Button type="button" variant="light" disabled={submitting} onClick={onReset}>
          Reset
        </Button>
      </div>
    </Form>
  );
};

export default DriverExpenseForm;
